<template>
  <div class="publicItems">
    <div class="selectionArea">
      <div class="item">
        <span class="title">名称</span>
        <el-input v-model="parameter.group_name" style="width: 200px;" placeholder="请输入内容" />
      </div>
      <el-button type="primary" icon="el-icon-search" @click="search">搜索</el-button>
      <el-button type="primary" icon="el-icon-refresh-left" @click="reset">重置</el-button>
      <el-button type="primary" icon="el-icon-circle-plus" @click="func">创建</el-button>
    </div>
    <div>
      <el-table
        v-loading="loading"
        :data="tableData.list"
        border
        style="width: 100%"
      >
        <el-table-column
          prop="id"
          label="投放组id"
        />
        <el-table-column
          prop="leader_name"
          label="组长"
        />

        <el-table-column
          prop="group_name"
          label="组名"
        />
        <el-table-column
          label="操作"
        >
          <template scope="scope">
            <el-button type="primary" size="mini" @click="modify(scope.row)">修改</el-button>
            <el-button type="primary" size="mini" @click="lookOver(scope.row)">查看</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>

    <pagination-right
      :total="tableData.count"
      @size-change="fetchPageSize"
      @current-change="fetchCurrentPage"
    />

    <el-dialog
      :title="data.id ? '修改投放组' : '创建投放组'"
      :visible.sync="dialogVisible"
      :close-on-click-modal="false"
      width="40%"
      @closed="(data.group_name = null),(data.id = null), (data.leader_id = null)"
    >
      <div class="content">
        <div class="item">
          <span class="item_title">投放组名称</span>
          <el-input v-model="data.group_name" class="item_input" />
        </div>
        <div class="item">
          <span class="item_title">组长</span>
          <el-select v-model="data.leader_id" filterable placeholder="请选择">
            <el-option
              v-for="item in groupLeaders"
              :key="item.id"
              :label="item.nickname"
              :value="item.id"
            />
          </el-select>
        </div>
      </div>
      <div style="display: flex; margin-top: 30px; justify-content: end;">
        <el-button type="primary" @click="determine">确定</el-button>
      </div>
    </el-dialog>
    <el-dialog
      title="绑定记录"
      :visible.sync="dialogVisiblenotes"
      :close-on-click-modal="false"
      :destroy-on-close="true"
      width="80%"
    >
      <!-- <bandnote ref="bandstaffnotesview" @updata="updata" /> -->
      <el-table
        v-loading="idloading"
        :data="tableList"
        border
        style="width: 100%"
      >
        <el-table-column
          prop="name"
          label="名称"
        />
        <el-table-column
          prop="key_words"
          label="关键字"
        >
          <template scope="scope">
            <ExpandClose
              :my-values="scope.row.key_words"
            />
          </template>
        </el-table-column>
        <el-table-column
          prop="created_at"
          label="创建时间"
        />
        <el-table-column
          prop="updated_at"
          label="修改时间"
        />
        <el-table-column
          prop="status"
          label="状态"
        >
          <!-- <template scope="scope">
            {{ scope.row.status === 1 ? '正常' : '禁用' }}
          </template> -->
          <template scope="scope">
            <div style="position: relative; display: inline-block;">
              <el-switch
                v-model="scope.row.status"
                :width="60"
                active-color="#13ce66"
                inactive-color="rgb(191,191,191)"
                :active-value="1"
                :inactive-value="2"
                disabled
                @change="statusChange(scope.row)"
              />
              <div
                v-if="scope.row.status === 1"
                style="color: #fff;position: absolute;top: 2px;left: 7px;"
              >正常</div>
              <div
                v-else
                style="color: #fff;position: absolute;top: 2px;right: 7px;"
              >禁用</div>
            </div>
          </template>
        </el-table-column>
      </el-table>
    </el-dialog>
  </div>
</template>

<script>
import ExpandClose from '@/components/ExpandClose/index.vue'

import { listMaterial_bind_groups, addMaterial_bind_groups, editMaterial_bind_groups, user_list, get_name_by_group_id } from '@/api/enormousAmountMaterialReport.js'
import PaginationRight from '@/components/PaginationRight/index.vue'
export default {
  components: {
    PaginationRight, ExpandClose
  },
  data() {
    return {
      tableData: {},
      tableList: [],
      loading: false,
      idloading: false,
      parameter: {
        page: 1,
        pageSize: 10,
        group_name: null
      },
      data: {
        leader_id: null,
        group_name: null,
        id: null
      },
      dialogVisible: false,
      groupLeaders: [],
      dialogVisiblenotes: false
    }
  },
  created() {
    this.getDataList()
  },
  methods: {
    async lookOver(row) {
      console.log('row:', row)
      const res = await get_name_by_group_id({
        group_id: row.id
      })
      this.idloading = true
      this.tableList = res.data.list
      if (Array.isArray(this.tableList) && this.tableList.length > 0) {
        this.dialogVisiblenotes = true
      } else {
        this.$message('暂无数据')
      }
      this.idloading = false
    },
    // 获取数据列表
    async getDataList() {
      this.loading = true
      const data = await listMaterial_bind_groups(this.parameter)
      this.tableData = data.data
      this.loading = false
    },

    // 修改
    async modify(row) {
      this.dialogVisible = true
      const data = await user_list()
      // console.log('修改', data, row)
      this.groupLeaders = data.data.user
      this.data.group_name = row.group_name
      this.data.leader_id = row.leader_id
      this.data.id = row.id
    },

    fetchPageSize(s) {
      this.parameter.pageSize = s
      this.getDataList()
    },

    fetchCurrentPage(s) {
      this.parameter.page = s
      this.getDataList()
    },

    async determine() {
      let text = null
      if (!this.data.group_name || !this.data.leader_id) {
        text = '请填写名称'
      }

      if (!text) {
        this.data.id ? await editMaterial_bind_groups(this.data.id, { leader_id: this.data.leader_id, group_name: this.data.group_name }) : await addMaterial_bind_groups({ ...this.data })
      }

      this.$message({
        message: text ? '请填写名称' : this.data.id ? '更新成功' : '创建成功',
        type: text ? 'warning' : 'success'
      })

      if (!text) {
        this.data.group_name = null
        this.data.leader_id = null
        this.data.id = null
        this.dialogVisible = false
        this.getDataList()
      }
    },

    // 搜索
    search() {
      this.parameter.page = 1
      this.getDataList()
    },

    async func() {
      this.dialogVisible = true
      const data = await user_list()
      this.groupLeaders = data.data.user
    },

    // 重置
    reset() {
      this.parameter = {
        page: 1,
        pageSize: 10,
        group_name: null
      }
      this.getDataList()
    }
  }
}
</script>
<style src="@/styles/public1.css"></style>

<style scoped lang="less">

.selectionArea{
  display: flex;
}

.content{
   .item{
     display: flex;
     align-items: center;
     margin-bottom: 15px;
    .item_title{
       display: inline-block;
       width: 100px;
    }
    .item_input{
       width: 200px
    }
   }
}

.item {
    display: flex;
    align-items: center;
    margin-right: 20px;
}

.title{
  display: inline-block;
  margin-right: 10px;
}
</style>
